module.exports = __webpack_public_path__ + "img/customer-a-101.c09271db.png";